import React from "react";
import { forwardRef } from "react";
import "../styles/AboutUs.css";
import "../styles/bg.css";
import AboutImage from "../assets/about-image.jpg";

const About = forwardRef((props, ref) => {
    return (
      <section ref={ref} className="about-us">
            <div className="main-background">
              <source className="main_bg_cont" />
            </div>
      <div className="about-us-container">
          <div className="about-us-text">
              <h1 className="about-us-title">About Us</h1>
              <p className="about-us-description">
              Welcome to <strong>INNOVASTRA</strong> – A National Level Hackathon, where innovation 
              meets technology to tackle real-world challenges. Inspired by India's 
              rich heritage and modern advancements, <strong>INNOVASTRA</strong> stands as the "Weapon 
              of Technology," empowering problem-solvers to shape the future with 
              groundbreaking solutions.
                <br></br>
              Hosted by <strong>Arya College of Engineering, Jaipur</strong>, this hackathon offers a 
              vibrant platform for students and tech enthusiasts to collaborate, code, 
              and compete. Participants will engage with cutting-edge problem statements, 
              receive expert mentorship, and showcase their skills on a national stage. 🚀
              </p>
          </div>
          <div className="about-us-image">
              <img src={AboutImage}></img>
          </div>
      </div>
  </section>
    );
});

export default About;

